import React, { useState, useEffect } from "react";
import axios from "axios";
import CONFIG from "./config";
import CustomAlert from "./CustomAlert";
import { useNavigate } from "react-router-dom";
import "./Datatable.css";
import Swal from "sweetalert2";
import "font-awesome/css/font-awesome.min.css";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useRef } from "react";

const DataTable = () => {
  const [form2Events, setForm2Events] = useState([]);
  const [alert, setAlert] = useState(null);
  const navigate = useNavigate();

  const handleClick = (id, memberName) => {
    Swal.fire({
      title: "Member Details",
      text: "",
      html: `
        <p class="confimrmodel">Are you sure you want to delete?</p>
        <p>${memberName}</p>
        <p class="warnmodel">
          <i class="fa fa-exclamation-triangle" style="font-size: 18px; color: #d33; margin-right: 8px;"></i>
          <span>You cannot recover the data after deleting.</span>
        </p>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id, memberName);
      }
    });
  };

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response2 = await axios.get(`${CONFIG.BASE_URL}/biodata/get/all`);

      setForm2Events(response2.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleDelete = async (id, memberName) => {
    try {
      await axios.delete(`${CONFIG.BASE_URL}/biodata/delete/${id}`);
      setForm2Events((prevEvents) =>
        prevEvents.filter((event) => event._id !== id)
      );
      toast.success("Bio data deleted successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (error) {
      toast.error("Error!", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const totalPages = Math.ceil(form2Events.length / itemsPerPage);
  const paginatedData = form2Events.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const [showModal, setShowModal] = useState(false);
  const buttonRef = useRef(null);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  const triggerButtonClick = () => {
    if (buttonRef.current) {
      buttonRef.current.click();
    }
  };

  return (
    <div className="custom-table-container wow fadeInUp" data-wow-delay="0.2s">
      <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
        <div className="breadcrumb-title pe-3">
          <ToastContainer />

          <h5>Board Members Details</h5>

          {alert && (
            <CustomAlert
              message={alert.message}
              onClose={() => setAlert(null)}
              type={alert.type}
            />
          )}
        </div>
        <div className="ms-auto">
          <div className="btn-group">
            <button
              onClick={() => navigate("/create-bio-data")}
              className="custom-btn-add"
            >
              {" "}
              + Add Data
            </button>
          </div>
        </div>
      </div>

      <table className="custom-data-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Image</th>
            <th>Member Name</th>
            <th>Organization Name</th>
            <th>Designation</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.map((item, index) => (
            <tr key={item._id}>
              <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
              <td>
                <img
                  className="d-block m-auto"
                  src={`${item.imagePath}`}
                  width={30}
                  height={30}
                  alt="Blog"
                />
              </td>
              <td>{item.memberName}</td>
              <td>{item.organizationName}</td>
              <td>{item.designation}</td>
              <td className="status_wrap text">
                <button
                  className="custom-btn-view datatbale_btn"
                  onClick={() =>
                    navigate("/view-bio-data", {
                      state: { bioDataProbs: item },
                    })
                  }
                >
                  <i className="fa fa-eye" style={{ color: "white" }}></i>
                </button>
                <button
                  className="custom-btn-edit datatbale_btn"
                  onClick={() =>
                    navigate("/update-bio-data", {
                      state: { bioDataProbs: item },
                    })
                  }
                >
                  {" "}
                  <i className="fa fa-pencil" style={{ color: "white" }}></i> {}
                </button>
                <button
                  className="custom-btn-delete datatbale_btn"
                  onClick={() => handleClick(item._id, item.memberName)}
                >
                  <i className="fa fa-trash" style={{ color: "white" }}></i> {}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pagination">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <i className="fa fa-chevron-left" aria-hidden="true"></i>
        </button>

        {/* Generate page numbers dynamically */}
        {Array.from({ length: 5 }).map((_, index) => {
          // Calculate the actual page number to display
          const pageNumber =
            currentPage <= 3 ? index + 1 : currentPage + index - 2;

          // Ensure pageNumber doesn't exceed totalPages and is greater than 0
          if (pageNumber < 1 || pageNumber > totalPages) {
            return null; // Skip invalid page numbers
          }

          return (
            <button
              key={pageNumber}
              onClick={() => handlePageChange(pageNumber)}
              className={currentPage === pageNumber ? "active" : ""}
            >
              {pageNumber}
            </button>
          );
        })}

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <i className="fa fa-chevron-right" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  );
};

export default DataTable;
